import React, { Component } from 'react';
import Promotor from './Promotor.jsx';



/**
 * Componente encargado de la búsqueda de promotores
 */
class Buscador extends Component {
    constructor(props) {
        super(props);
        this.state={
            filteredArray:[]
        }
    this.filtrarArray = this.filtrarArray.bind(this)    
    }
filtrarArray(arr,event){
    let valor = event.target.value
    if(valor!=""){
        let resultado = arr.filter((promotor)=>promotor.Descripcion.toLowerCase().match(valor.toLowerCase()))
        this.setState({filteredArray:resultado})
    }else{
        let resultado = []
        this.setState({filteredArray:resultado})
    }
}

    render() {
        let promotoresVista = null;
        //let arrayMock = ["cosa","cosita","lalala","esas cositas las quiero","hacelaquetedije","ayudame flaco", "aaaaaaaaaarrrrgghhh","la tiene y se hace famoso","aguante la renga","que miras vigilante","me gusta el polem","skibiddi pap", "skibidi wapapapapa","ta ra ra ra ra hey!"]
        const {seleccionarPromotor,promotores } = this.props

        if (this.state.filteredArray.length>0) {
            let promotoresArray = this.state.filteredArray
            promotoresVista = (<div>
                {promotoresArray.map((promotor)=>{
                    return <Promotor seleccionarPromotor={seleccionarPromotor} prom={promotor}/>
                })}
            </div>)

        }
        return (
            <div className="form-group  input-icon-container">
                        <span className="ti-search-new input-icon-span-new"></span>
        <input onChange={(e)=>this.filtrarArray(promotores,e)} className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs in-adicional busqueda-alta-new" type="text" placeholder="Buscar por Nombre..." />
                        <div>
                            {promotoresVista}
                        </div>
            </div>
        );
    }
};

export default Buscador;